import { render, staticRenderFns } from "./flashSale.vue?vue&type=template&id=6d23410e&scoped=true&"
import script from "./flashSale.vue?vue&type=script&lang=js&"
export * from "./flashSale.vue?vue&type=script&lang=js&"
import style0 from "./flashSale.vue?vue&type=style&index=0&id=6d23410e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d23410e",
  null
  
)

export default component.exports